// extracted by mini-css-extract-plugin
export var container = "_rx-0";
export var dotAnimation = "_rx-2";
export var dotsLoading = "_rx-1";